import './App.scss';
import AssurancesSection from './components/AssurancesSection';
import LandingPage from './templates/LandingPage';
import SectionConsultation from './sections/SectionConsultation';
import SectionContact from './sections/SectionContact';
import SectionHeroAssurances from './sections/SectionHeroAssurances';


function Assurances() {
    return (
      <div className="App">
        <LandingPage>
           <SectionHeroAssurances/>
            <AssurancesSection />
            <SectionConsultation/>
            <SectionContact/>
        </LandingPage>
      </div>
    );
  }
  
  export default Assurances;
  